import { render, staticRenderFns } from "./LoginBanner.vue?vue&type=template&id=6cf93c4b&scoped=true"
import script from "./LoginBanner.vue?vue&type=script&lang=js"
export * from "./LoginBanner.vue?vue&type=script&lang=js"
import style0 from "./LoginBanner.vue?vue&type=style&index=0&id=6cf93c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf93c4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
